import React, { useEffect, useState } from "react";
import {
	Container,
	CssBaseline,
	Typography,
	TextField,
	Box,
	Grid,
	Select,
	FormControl,
	MenuItem,
	InputLabel,
} from "@material-ui/core";
import { Form, Formik } from "formik";
import { Link, withRouter, useLocation, useParams } from "react-router-dom";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import useStyles from "../../assests/styles/views/auth/login";
import Copyright from "../../utils/copyRightUtils";
import { TransparentLogo } from "../../components/Logo";
import ButtonWithLoading from "../../components/ButtonWithLoading";
import {
	userLogin,
	getCustomerApps,
	Post,
	verifyInternalAppLogin,
} from "../../actions";
import checkResponse from "../../heplers/responseHelper";
import { useSnackbar } from "notistack";
import authUtils from "../../utils/authUtils";
import authService from "../../utils/authUtils";
import { Post_VerifyInternalAppLogin_URL } from "../../constants/apiUrls";
import CircularProgress from "@material-ui/core/CircularProgress";
import { getTranslation } from "../../heplers/translationHelper";
import theme from "../../theme";
const Login = ({ history }) => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const location = useLocation();
	const { enqueueSnackbar } = useSnackbar();
	const [customerAppsLoading, setCustomerAppsLoading] = useState(false);
	const params = useParams();
	const [customerApps, setCustomerApps] = useState([]);
	const [lastLocation, setLastLocation] = useState("");
	const [showStep, setShowStep] = useState(false);
	const [isLoginInfoLoaded, setIsLoginInfoLoaded] = useState(false);
	const  selectedOrganization = localStorage.getItem("selectedOrganization");

	useEffect(() => {
		const token = params.token;
		if (authService.isAuthenticated() || authService.isRefreshAuthenticated()) {
			history.push("/account/profile");
		} else if (token) {
			verifyInternalAppLogin(
				{ token: token },
				(res) => {
					authService.logout();
					authUtils.setUser(res.data.appUser);
					authUtils.setSession(res.data.accessToken);
					sessionStorage.setItem("role", res.data.appUser.role);
					authUtils.setUserRefreshToken(
						res.data.refreshToken,
						res.data.refreshTokenExpire
					);
					authUtils.setCustomerId(res.data.customerId);
					if (res.data.roles.includes("Admin"))
						history.push("/admin");
					else if (res.data.roles.includes("Customer"))
						history.push("/customer");
					else if (res.data.roles.includes("Manager"))
						history.push("/manager");
					else if (res.data.roles.includes("Staff"))
						history.push("/staff");
					else if (res.data.roles.includes("ZCash"))
						history.push("/zcash");

					//actions.setSubmitting(false);
					enqueueSnackbar(
						getTranslation(
							" Welcome to the app ",
							" Bienvenue sur l'application ",
							" Willkommen in der App "
						),
						{ variant: "success" }
					);
				},
				(error) => {
					setIsLoginInfoLoaded(true);
					enqueueSnackbar(
						getTranslation(
							" Invalid Token ",
							" jeton invalide ",
							" Ung�ltiges Token "
						),
						{ variant: "error" }
					);
				}
			);
		} else {
			setIsLoginInfoLoaded(true);
		}
	}, []);
	let schema = Yup.string().email(getTranslation("Invalid"));
	return (
		<Container component="main" maxWidth="xs">
			<CssBaseline />
			{isLoginInfoLoaded ? (
				<div className={classes.paper}>
					<div className={classes.logo}>
						<TransparentLogo />
					</div>
					<br />
					<Typography
						component="h1"
						variant="h2"
						// color={theme.palette.primary.contrastText}
						style={{ color: "black" }}
					>
						{getTranslation("Login", "Connexion", "Anmeldung")}
					</Typography>
					<br />
					<Formik
						initialValues={{
							email: "",
							password: "",
							organizationName: "",
							appId: 4,
							customerId: selectedOrganization || "",
						}}
						validationSchema={Yup.object().shape({
							email: Yup.string().email(
								getTranslation(
									"Please enter a valid Email",
									"Please enter a valid Email",
									"Please enter a valid Email"
								)
							),
							password: Yup.string().required(
								getTranslation(
									"Password is required",
									"Password is required",
									"Password is required"
								)
							),
							// customerId: Yup.string().required(
							// 	getTranslation(
							// 		"Organization is required",
							// 		"Organization is required",
							// 		"Organization is required"
							// 	)
							// ),
						})}
						onSubmit={(values, actions) => {
							actions.setSubmitting(true);
							
							dispatch(userLogin(values)).then((res) => {
								if (checkResponse(res)) {
									actions.setSubmitting(false);
									if(res?.data.includes("Your Account is in-active please contact admin"))
										enqueueSnackbar(getTranslation("Your Account is in-active please contact admin"), { variant: "error" })
									else
									enqueueSnackbar(getTranslation("Invalid Login"), { variant: "error" })
									
									return;
								}

								authUtils.setSession(res.data.accessToken);
								authUtils.setUserRefreshToken(
									res.data.refreshToken,
									res.data.expiresIn
								);
								if (res.data.roles.includes("Admin"))
									history.push("/admin");
								else if (res.data.roles.includes("Customer"))
									history.push("/customer");
								else if (res.data.roles.includes("Manager"))
									history.push("/manager");
								else if (res.data.roles.includes("Staff"))
									history.push("/staff");
								else if (res.data.roles.includes("ZCash"))
									history.push("/zcash");
							});
							actions.setSubmitting(false);

						}}           
					>
						{({
							values,
							errors,
							touched,
							handleChange,
							handleSubmit,
							validateForm,
							setFieldValue,
							isSubmitting,
						}) => (
							<Form className={classes.form}>
								
										<TextField
											variant="outlined"
											margin="normal"
											required
											fullWidth
											id="email"
											label={getTranslation(
												"Email Address",
												"Adresse e-mail",
												"E-Mail-Addresse"
											)}
											name="email"
											autoComplete="email"
											autoFocus
											size="small"
											value={values.email}
											onChange={handleChange}
											error={touched.email && Boolean(errors.email)}
											helperText={touched.email && errors.email}
										/>
										<TextField
											variant="outlined"
											margin="normal"
											required
											fullWidth
											size="small"
											name="password"
											label={getTranslation(
												"Password",
												"Mot de passe",
												"Kennwort"
											)}
											type="password"
											id="password"
											value={values.password}
											onChange={handleChange}
											error={touched.password && Boolean(errors.password)}
											helperText={touched.password && errors.password}
										/>
								
										
										<ButtonWithLoading
											color="primary"
											textColor="white"
											type="submit"
											title={getTranslation("Login", "Connexion", "Anmeldung")}
											fullWidth
											variant="contained"
											loading={isSubmitting}
											onClick={handleSubmit}
											className={classes.submit}
										/>

										<Grid container>
											<Grid item xs>
												<Link
													to="/forget_password"
													color="secondary"
													variant="body1"
												>
													{/* <Typography color="textSecondary">
                            {getTranslation(
                              "Forget Password",
                              "Mot de passe oubli�",
                              "Passwort vergessen"
                            )}
                          </Typography> */}
												</Link>
											</Grid>
										</Grid>
										<Box mt={3}>
											<Copyright />
										</Box>
									
							</Form>
						)}
					</Formik>
				</div>
			) : (
				<Grid
					container
					spacing={0}
					direction="column"
					alignItems="center"
					justify="center"
					style={{ minHeight: "100vh" }}
				>
					<CircularProgress />
				</Grid>
			)}
		</Container>
	);
};

export default withRouter(Login);